<template>
  <a-card title="Cài đặt X Cookies" :loading="loading">
    <a-alert message="Các cookies X này sẽ được sử dụng để checklive cho tài khoản X (nên dùng acc đã suspend)" type="info" show-icon />
    <br>
    <a-textarea
      v-model="cookies"
      placeholder="X cookies"
      :auto-size="{ minRows: 20, maxRows: 20 }"
      class="custom-textarea"
    />
    <br><br>
    <div id="actions">
      <a-button type="primary" @click="handleSetXCookies()">Lưu lại</a-button>
    </div>
  </a-card>
</template>

<style scoped>
.custom-textarea {
  white-space: nowrap;
  overflow-x: auto;
}
</style>

<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      cookies: '',
      loading: false
    }
  },
  computed: {

  },
  mounted() {
    this.handleGetXCookies();
  },
  methods: {
    ...mapActions('facebookAccount', {
      getXCookies: 'getXCookies',
      setXCookies: "setXCookies"
    }),

    async handleGetXCookies() {
      this.loading = true;
      this.cookies = await this.getXCookies();
      this.loading = false;
    },

    async handleSetXCookies() {
      this.loading = true;
      await this.setXCookies({cookies: this.cookies});
      this.loading = false;
      this.$message.success('Lưu X cookies thành công!');
    }
  }
}
</script>